<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" :style="{'font-size': size+'px'}" />
    <div class="main-container" :style="{'font-size': size+'px'}">
      <navbar />
      <tags-view />
      <app-main />


    </div>
  </div>
</template>

<script>
  import {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  } from './components'
  import ResizeMixin from './mixin/ResizeHandler'
  export default {
    name: 'Layout',
    components: {
      Navbar,
      Sidebar,
      AppMain,
      TagsView,
    },
    mixins: [ResizeMixin],
    computed: {
      sidebar() {
        return this.$store.state.app.sidebar
      },
      size() {
        return this.$store.state.app.size
      },
      device() {
        return this.$store.state.app.device
      },
      classObj() {
        return {
          hideSidebar: !this.sidebar.opened,
          openSidebar: this.sidebar.opened,
          withoutAnimation: this.sidebar.withoutAnimation,
          mobile: this.device === 'mobile',
        }
      }
    },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('closeSideBar', {
          withoutAnimation: false
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~@/styles/mixin.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  /deep/ {
    .el-form-item__content,
    .el-form-item__content .el-input,
    .el-form-item__content input,
    .el-form-item__content .el-button,
    .el-table,
    .el-button,
    .el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__sizes .el-input__inner,
    .el-input,
    .el-pagination__jump,
    .el-pager,
    .el-pager .number,
      {
      font-size: inherit !important;
    }
  }
</style>
